import uniq from "lodash/uniq";

import type { ActivationObjectSchema } from "app/pages/activation/types/api";

export const getAllDomains = (activationSetList: ActivationObjectSchema[]) =>
    uniq(
        activationSetList.reduce((acc, { competitorsDomains, primaryDomain }) => {
            acc.push(primaryDomain, ...competitorsDomains);
            return acc;
        }, [] as string[]),
    );
